var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useNFC)?_c('div',{staticClass:"nfc-reader"},[_c('div',{staticClass:"dot",style:({ backgroundColor: _vm.isComOpen ? '#19be6b' : 'red' })}),_vm._v("\n  NFC\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }